import { getCustomerExams } from '@/lib/firebase/queries/exams/getExams';
import { loadPerson } from '@/lib/firebase/queries/namatAssessment';
import { buildExamReport, type ExamReport, type ReportExam } from '@/lib/assessment/examTrends';

/** The exam report over time of one beneficiary (#112): all their exams and their birth date and sex. */
export async function loadExamReport(customerId: string): Promise<ExamReport> {
  const [exams, person] = await Promise.all([getCustomerExams(customerId), loadPerson(customerId)]);
  return buildExamReport(exams as unknown as ReportExam[], person);
}
